/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendMonitoringCapexDto } from '../models/backend-monitoring-capex-dto';
import { BackendMonitoringCreditDto } from '../models/backend-monitoring-credit-dto';
import { BackendMonitoringLeasingContractDto } from '../models/backend-monitoring-leasing-contract-dto';
import { BackendMonitoringMaterialProductPlanDto } from '../models/backend-monitoring-material-product-plan-dto';
import { BackendMonitoringOpexDto } from '../models/backend-monitoring-opex-dto';
import { BackendMonitoringOwnFundDto } from '../models/backend-monitoring-own-fund-dto';
import { BackendMonitoringRentPlanDto } from '../models/backend-monitoring-rent-plan-dto';
import { BackendMonitoringSalaryAggregateDto } from '../models/backend-monitoring-salary-aggregate-dto';
import { BackendMonitoringScenarioDetailDto } from '../models/backend-monitoring-scenario-detail-dto';
import { monitoringScenariosCapexesList } from '../fn/monitoring-scenario-data/monitoring-scenarios-capexes-list';
import { MonitoringScenariosCapexesList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-capexes-list';
import { monitoringScenariosCreditsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-credits-list';
import { MonitoringScenariosCreditsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-credits-list';
import { monitoringScenariosLeasingsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-leasings-list';
import { MonitoringScenariosLeasingsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-leasings-list';
import { monitoringScenariosOpexesList } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-list';
import { MonitoringScenariosOpexesList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-list';
import { monitoringScenariosOpexesMaterialsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-materials-list';
import { MonitoringScenariosOpexesMaterialsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-materials-list';
import { monitoringScenariosOpexesOtherOpexesList } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-other-opexes-list';
import { MonitoringScenariosOpexesOtherOpexesList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-other-opexes-list';
import { monitoringScenariosOpexesProductsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-products-list';
import { MonitoringScenariosOpexesProductsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-products-list';
import { monitoringScenariosOpexesRentsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-rents-list';
import { MonitoringScenariosOpexesRentsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-rents-list';
import { monitoringScenariosOpexesSalariesRetrieve } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-salaries-retrieve';
import { MonitoringScenariosOpexesSalariesRetrieve$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-opexes-salaries-retrieve';
import { monitoringScenariosOwnFundsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-own-funds-list';
import { MonitoringScenariosOwnFundsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-own-funds-list';
import { monitoringScenariosProductsList } from '../fn/monitoring-scenario-data/monitoring-scenarios-products-list';
import { MonitoringScenariosProductsList$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-products-list';
import { monitoringScenariosRetrieve } from '../fn/monitoring-scenario-data/monitoring-scenarios-retrieve';
import { MonitoringScenariosRetrieve$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-retrieve';
import { monitoringScenariosTaxesRetrieve } from '../fn/monitoring-scenario-data/monitoring-scenarios-taxes-retrieve';
import { MonitoringScenariosTaxesRetrieve$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-taxes-retrieve';
import { monitoringScenariosWorkingCapitalRetrieve } from '../fn/monitoring-scenario-data/monitoring-scenarios-working-capital-retrieve';
import { MonitoringScenariosWorkingCapitalRetrieve$Params } from '../fn/monitoring-scenario-data/monitoring-scenarios-working-capital-retrieve';
import { BackendMonitoringStandardProductDto } from '../models/backend-monitoring-standard-product-dto';
import { BackendMonitoringTaxPlanDto } from '../models/backend-monitoring-tax-plan-dto';
import { BackendMonitoringWorkingCapitalPlanDto } from '../models/backend-monitoring-working-capital-plan-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringScenarioDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringScenariosRetrieve()` */
  static readonly MonitoringScenariosRetrievePath = '/api/monitoring/scenarios/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosRetrieve$Response(
    params: MonitoringScenariosRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringScenarioDetailDto>> {
    return monitoringScenariosRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosRetrieve(
    params: MonitoringScenariosRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringScenarioDetailDto> {
    return this.monitoringScenariosRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMonitoringScenarioDetailDto>): BackendMonitoringScenarioDetailDto => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosCapexesList()` */
  static readonly MonitoringScenariosCapexesListPath = '/api/monitoring/scenarios/{scenario_id}/capexes/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosCapexesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosCapexesList$Response(
    params: MonitoringScenariosCapexesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringCapexDto>>> {
    return monitoringScenariosCapexesList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosCapexesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosCapexesList(
    params: MonitoringScenariosCapexesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringCapexDto>> {
    return this.monitoringScenariosCapexesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringCapexDto>>): Array<BackendMonitoringCapexDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosCreditsList()` */
  static readonly MonitoringScenariosCreditsListPath = '/api/monitoring/scenarios/{scenario_id}/credits/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosCreditsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosCreditsList$Response(
    params: MonitoringScenariosCreditsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringCreditDto>>> {
    return monitoringScenariosCreditsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosCreditsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosCreditsList(
    params: MonitoringScenariosCreditsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringCreditDto>> {
    return this.monitoringScenariosCreditsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringCreditDto>>): Array<BackendMonitoringCreditDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosLeasingsList()` */
  static readonly MonitoringScenariosLeasingsListPath = '/api/monitoring/scenarios/{scenario_id}/leasings/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosLeasingsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosLeasingsList$Response(
    params: MonitoringScenariosLeasingsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringLeasingContractDto>>> {
    return monitoringScenariosLeasingsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosLeasingsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosLeasingsList(
    params: MonitoringScenariosLeasingsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringLeasingContractDto>> {
    return this.monitoringScenariosLeasingsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendMonitoringLeasingContractDto>>,
        ): Array<BackendMonitoringLeasingContractDto> => r.body,
      ),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesList()` */
  static readonly MonitoringScenariosOpexesListPath = '/api/monitoring/scenarios/{scenario_id}/opexes/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesList$Response(
    params: MonitoringScenariosOpexesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringOpexDto>>> {
    return monitoringScenariosOpexesList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesList(
    params: MonitoringScenariosOpexesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringOpexDto>> {
    return this.monitoringScenariosOpexesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringOpexDto>>): Array<BackendMonitoringOpexDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesMaterialsList()` */
  static readonly MonitoringScenariosOpexesMaterialsListPath =
    '/api/monitoring/scenarios/{scenario_id}/opexes/materials/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesMaterialsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesMaterialsList$Response(
    params: MonitoringScenariosOpexesMaterialsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>> {
    return monitoringScenariosOpexesMaterialsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesMaterialsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesMaterialsList(
    params: MonitoringScenariosOpexesMaterialsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringMaterialProductPlanDto>> {
    return this.monitoringScenariosOpexesMaterialsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>,
        ): Array<BackendMonitoringMaterialProductPlanDto> => r.body,
      ),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesOtherOpexesList()` */
  static readonly MonitoringScenariosOpexesOtherOpexesListPath =
    '/api/monitoring/scenarios/{scenario_id}/opexes/other-opexes/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesOtherOpexesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesOtherOpexesList$Response(
    params: MonitoringScenariosOpexesOtherOpexesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringOpexDto>>> {
    return monitoringScenariosOpexesOtherOpexesList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesOtherOpexesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesOtherOpexesList(
    params: MonitoringScenariosOpexesOtherOpexesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringOpexDto>> {
    return this.monitoringScenariosOpexesOtherOpexesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringOpexDto>>): Array<BackendMonitoringOpexDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesProductsList()` */
  static readonly MonitoringScenariosOpexesProductsListPath =
    '/api/monitoring/scenarios/{scenario_id}/opexes/products/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesProductsList$Response(
    params: MonitoringScenariosOpexesProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>> {
    return monitoringScenariosOpexesProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesProductsList(
    params: MonitoringScenariosOpexesProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringMaterialProductPlanDto>> {
    return this.monitoringScenariosOpexesProductsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendMonitoringMaterialProductPlanDto>>,
        ): Array<BackendMonitoringMaterialProductPlanDto> => r.body,
      ),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesRentsList()` */
  static readonly MonitoringScenariosOpexesRentsListPath = '/api/monitoring/scenarios/{scenario_id}/opexes/rents/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesRentsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesRentsList$Response(
    params: MonitoringScenariosOpexesRentsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringRentPlanDto>>> {
    return monitoringScenariosOpexesRentsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesRentsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesRentsList(
    params: MonitoringScenariosOpexesRentsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringRentPlanDto>> {
    return this.monitoringScenariosOpexesRentsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringRentPlanDto>>): Array<BackendMonitoringRentPlanDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosOpexesSalariesRetrieve()` */
  static readonly MonitoringScenariosOpexesSalariesRetrievePath =
    '/api/monitoring/scenarios/{scenario_id}/opexes/salaries/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOpexesSalariesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesSalariesRetrieve$Response(
    params: MonitoringScenariosOpexesSalariesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringSalaryAggregateDto>> {
    return monitoringScenariosOpexesSalariesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOpexesSalariesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOpexesSalariesRetrieve(
    params: MonitoringScenariosOpexesSalariesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringSalaryAggregateDto> {
    return this.monitoringScenariosOpexesSalariesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMonitoringSalaryAggregateDto>): BackendMonitoringSalaryAggregateDto => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosOwnFundsList()` */
  static readonly MonitoringScenariosOwnFundsListPath = '/api/monitoring/scenarios/{scenario_id}/own-funds/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosOwnFundsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOwnFundsList$Response(
    params: MonitoringScenariosOwnFundsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringOwnFundDto>>> {
    return monitoringScenariosOwnFundsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosOwnFundsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosOwnFundsList(
    params: MonitoringScenariosOwnFundsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringOwnFundDto>> {
    return this.monitoringScenariosOwnFundsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMonitoringOwnFundDto>>): Array<BackendMonitoringOwnFundDto> => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosProductsList()` */
  static readonly MonitoringScenariosProductsListPath = '/api/monitoring/scenarios/{scenario_id}/products/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosProductsList$Response(
    params: MonitoringScenariosProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMonitoringStandardProductDto>>> {
    return monitoringScenariosProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosProductsList(
    params: MonitoringScenariosProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMonitoringStandardProductDto>> {
    return this.monitoringScenariosProductsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendMonitoringStandardProductDto>>,
        ): Array<BackendMonitoringStandardProductDto> => r.body,
      ),
    );
  }

  /** Path part for operation `monitoringScenariosTaxesRetrieve()` */
  static readonly MonitoringScenariosTaxesRetrievePath = '/api/monitoring/scenarios/{scenario_id}/taxes/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosTaxesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosTaxesRetrieve$Response(
    params: MonitoringScenariosTaxesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringTaxPlanDto>> {
    return monitoringScenariosTaxesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosTaxesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosTaxesRetrieve(
    params: MonitoringScenariosTaxesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringTaxPlanDto> {
    return this.monitoringScenariosTaxesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMonitoringTaxPlanDto>): BackendMonitoringTaxPlanDto => r.body),
    );
  }

  /** Path part for operation `monitoringScenariosWorkingCapitalRetrieve()` */
  static readonly MonitoringScenariosWorkingCapitalRetrievePath =
    '/api/monitoring/scenarios/{scenario_id}/working-capital/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringScenariosWorkingCapitalRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosWorkingCapitalRetrieve$Response(
    params: MonitoringScenariosWorkingCapitalRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMonitoringWorkingCapitalPlanDto>> {
    return monitoringScenariosWorkingCapitalRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringScenariosWorkingCapitalRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringScenariosWorkingCapitalRetrieve(
    params: MonitoringScenariosWorkingCapitalRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendMonitoringWorkingCapitalPlanDto> {
    return this.monitoringScenariosWorkingCapitalRetrieve$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendMonitoringWorkingCapitalPlanDto>): BackendMonitoringWorkingCapitalPlanDto =>
          r.body,
      ),
    );
  }
}
